module.exports = __webpack_public_path__ + "static/img/design-tools-sync.2f1f9973.svg";